import { H4 } from "../../../../../AbstractElements";
import { Invoice5FourData, InvoiceFourData } from "../../../../../Data/Applications/ECommerce/ECommerce";

const InvoiceTableBody = () => {
  return (
    <tbody>
      {InvoiceFourData.map((data, i) => (
        <tr key={i}>
          <td style={{ width: "12%", textAlign: "center", borderBottom: "1px dashed rgba(82, 82, 108, 0.2)", background: "#F5F6F9" }}>
            <span style={{ opacity: "0.8", fontWeight: 600 }}>{i + 1}</span>
          </td>
          <td style={{ padding: 16, borderBottom: "1px dashed rgba(82, 82, 108, 0.2)" }}>
            <H4 style={{ fontWeight: 600, margin: "4px 0px", fontSize: 18, color: "#2A5699" }}>{data.title}</H4>
            <span style={{ opacity: "0.8", fontSize: 16 }}>{data.detail}</span>
          </td>
          <td style={{ width: "12%", textAlign: "center", borderBottom: "1px dashed rgba(82, 82, 108, 0.2)", background: "#F5F6F9" }}>
            <span style={{ fontWeight: 600 }}>${data.price}.00</span>
          </td>
          <td style={{ width: "12%", textAlign: "center", borderBottom: "1px dashed rgba(82, 82, 108, 0.2)" }}>
            <span style={{ fontWeight: 600 }}>{data.quantity}</span>
          </td>
          <td style={{ width: "12%", textAlign: "center", borderBottom: "1px dashed rgba(82, 82, 108, 0.2)", background: "#F5F6F9" }}>
            <span style={{ color: "#2A5699", fontWeight: 600, opacity: "0.9" }}>${data.total}.00</span>
          </td>
        </tr>
      ))}
      {Invoice5FourData.map((data, index) => (
        <tr key={index}>
          <td> </td><td> </td><td> </td>
          <td style={{ textAlign: "center", padding: "0px" }}>
            <span style={{ opacity: 0.8, fontWeight: 600 }}>{data.title}</span>
          </td>
          <td style={{ textAlign: "center", display: "block", padding: "3px" ,background: "#F5F6F9" }}>
            <span style={{ fontWeight: 600, opacity: 0.9 }}>{data.price}</span>
          </td>
        </tr>
      ))}
      <tr>
        <td> </td><td> </td><td></td>
        <td style={{ width: "12%", textAlign: "center", padding: "0px" }}>
          <span style={{ opacity: 0.8, fontWeight: 600 }}>Total Due</span>
        </td>
        <td style={{ textAlign: "center", padding: "0px" }}>
          <span style={{ color: "#dee2e6", fontWeight: 600, opacity: 0.9, background: "#2A5699", padding: "12px 37px", marginTop: "0px", display: "block" }}>$6120.00</span>
        </td>
      </tr>
    </tbody>
  );
};
export default InvoiceTableBody;
